import { createContext } from "react"

export const initialSearchState = {
  documentation: [],
  apiReference: [],
  documentationLoading: false,
  apiReferenceLoading: false
}

const SearchModalContext = createContext(false)

export default SearchModalContext
